import { Component, Inject, TemplateRef, ViewChild } from '@angular/core';

import { TwcPopupComponent } from '@topcon/twc-angular';

import { UiConfigurationService } from '@mirage-projects/cw-commons';
import { CommonsConfigEnvironment, CONFIG_ENVIRONMENT } from '@mirage-projects/cw-models';

@Component({
    selector: 'cw-about-dialog',
    templateUrl: './about-dialog.component.html',
    styleUrls: ['./about-dialog.component.scss'],
    standalone: false,
})
export class AboutDialogComponent {
    @ViewChild('aboutDialogComponent', { static: false })
    aboutDialogComponent!: TemplateRef<TwcPopupComponent>;
    collageWebLogoImg = `${this.uiConfigurationService.uiConfiguration.imgFolder}Magnet_CollageWeb_Logo_Blue_RGB-svg.png`;

    constructor(
        @Inject(CONFIG_ENVIRONMENT) private configEnvironment: CommonsConfigEnvironment,
        private uiConfigurationService: UiConfigurationService
    ) {}

    get version(): string {
        return this.configEnvironment.productVersion;
    }
}
